export default "__VITE_ASSET__Bh1wd0WJ__"